export { default } from '@shikijs/langs/r'
